import { GridOptions } from 'ag-grid-community';

export interface IDataGridConfig {
  columnDefs?: any;
  defaultColDef?: any;
  rowSelection?: any;
  domLayout?: string;
  gridOptions?: GridOptions;
  frameworkComponents?: any;
  gridCompact?: boolean;
  gridStriped?: boolean;
  selectionLimit?: number;
}

export class DataGridConfig implements IDataGridConfig {
  columnDefs?: any;
  defaultColDef?: any;
  rowSelection?: any;
  domLayout?: string;
  gridOptions?: GridOptions;
  frameworkComponents?: any;
  gridCompact?: boolean;
  gridStriped?: boolean;
  selectionLimit?: number;

  constructor(
    columnDefs: any,
    defaultColDef?: any,
    rowSelection?: any,
    domLayout?: string,
    gridOptions?: GridOptions,
    frameworkComponents?: any,
    gridCompact?: boolean,
    gridStriped?: boolean,
    selectionLimit?: number,
  ) {
    this.columnDefs = columnDefs;
    this.defaultColDef = defaultColDef;
    this.rowSelection = rowSelection;
    this.domLayout = domLayout;
    this.gridOptions = gridOptions;
    this.frameworkComponents = frameworkComponents;
    this.gridCompact = gridCompact;
    this.gridStriped = gridStriped;
    this.selectionLimit = selectionLimit;
  }
}
